import { Box, styled } from '@mui/material'
import { SECTION_SPACING } from '../../Config/layoutConstants'

/**
 * A wrapper component for content sections with consistent spacing.
 * Use this to create vertical separation between major content blocks.
 *
 * @example
 * <ContentSection>
 *   <SectionHeader>First Section</SectionHeader>
 *   <TableWrapper>...</TableWrapper>
 * </ContentSection>
 * <ContentSection>
 *   <SectionHeader>Second Section</SectionHeader>
 *   <TableWrapper>...</TableWrapper>
 * </ContentSection>
 */
export const ContentSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(SECTION_SPACING),
}))

export default ContentSection
